import { AmplitudeFeatureFlagNames } from '@/libs/feature-flags';
import { CirclePartner, CirclePartnerConfig } from '@calm/evexia-web-sdk';
import { useAmplitudeExperiment } from '@rhg/hooks/use-experiments';

export interface TransitionDestinationPartner {
    id: string;
    name: string;
    slug: string;
}

export interface UseTransitionPartnerResult {
    isLoading: boolean;
    isFetched: boolean;
    destinationPartner: TransitionDestinationPartner | null;
}

// CirclePartner and CirclePartnerConfig are separately-generated SDK types
// that both carry partnerTransition in the same shape — the only field this
// module reads. Accepting either avoids a cast at call sites resolving a
// partner from an access code (a public CirclePartnerConfig) rather than a
// full authenticated CirclePartner; utils/partner's
// getIsPartnerRelatedSponsorship already does the same for the same reason.
export function getTransitionDestinationPartner(
    partner?: CirclePartner | CirclePartnerConfig | null
): TransitionDestinationPartner | null {
    const partnerTransition = partner?.partnerTransition;
    if (!partnerTransition) {
        return null;
    }
    const { id, name, slug } = partnerTransition;
    if (!id || !name || !slug) {
        return null;
    }
    return { id, name, slug };
}

export function useTransitionPartner(
    partner?: CirclePartner | CirclePartnerConfig | null
): UseTransitionPartnerResult {
    const {
        isEnrolled: isFlagEnabled,
        isLoading,
        isFetched,
    } = useAmplitudeExperiment({
        experimentName: AmplitudeFeatureFlagNames.BUY_UP_ENABLED,
    });

    return {
        isLoading,
        isFetched,
        destinationPartner: isFlagEnabled
            ? getTransitionDestinationPartner(partner)
            : null,
    };
}
